import { createI18n } from "vue-i18n";
import store from '@/store'
import { getLang } from '@/utils'
import storage from '@/utils/storage'

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import enGB from 'ant-design-vue/es/locale/en_GB'
import koKO from 'ant-design-vue/es/locale/ko_KR'
import jaJP from 'ant-design-vue/es/locale/ja_JP'

import EN from "./lang/en";
import ZH from "./lang/zh";
import KO from "./lang/ko";
import JP from "./lang/jp";

const messages = {
  zh: {
		...zhCN,
    ...ZH,
  },
  en: {
		...enGB,
    ...EN,
  },
  ko: {
		...koKO,
    ...KO,
  },
  jp: {
		...jaJP,
    ...JP,
  },
};
const i18n = createI18n({
  silentTranslationWarn: true,
 locale: storage.getStorage('lang') ? getLang()['transform'][storage.getStorage('lang')] : getLang()['transform'][store.state.lang], // 设置当前语言类型
  globalInjection:true,
  legacy:false,
  messages,
  warnHtmlMessage: false
});

export default i18n;
